export default "__VITE_ASSET__aaf0708f__"